/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetCompanyDto } from './GetCompanyDto';
import {
    GetCompanyDtoFromJSON,
    GetCompanyDtoFromJSONTyped,
    GetCompanyDtoToJSON,
} from './GetCompanyDto';
import type { GetSalesInvoicePositionDto } from './GetSalesInvoicePositionDto';
import {
    GetSalesInvoicePositionDtoFromJSON,
    GetSalesInvoicePositionDtoFromJSONTyped,
    GetSalesInvoicePositionDtoToJSON,
} from './GetSalesInvoicePositionDto';
import type { GetAttachmentDto } from './GetAttachmentDto';
import {
    GetAttachmentDtoFromJSON,
    GetAttachmentDtoFromJSONTyped,
    GetAttachmentDtoToJSON,
} from './GetAttachmentDto';
import type { GetExaminedDto } from './GetExaminedDto';
import {
    GetExaminedDtoFromJSON,
    GetExaminedDtoFromJSONTyped,
    GetExaminedDtoToJSON,
} from './GetExaminedDto';
import type { GetUserDto } from './GetUserDto';
import {
    GetUserDtoFromJSON,
    GetUserDtoFromJSONTyped,
    GetUserDtoToJSON,
} from './GetUserDto';
import type { GetDictionaryDto } from './GetDictionaryDto';
import {
    GetDictionaryDtoFromJSON,
    GetDictionaryDtoFromJSONTyped,
    GetDictionaryDtoToJSON,
} from './GetDictionaryDto';

/**
 * 
 * @export
 * @interface GetSalesInvoiceDto
 */
export interface GetSalesInvoiceDto {
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceDto
     */
    number: string;
    /**
     * 
     * @type {Date}
     * @memberof GetSalesInvoiceDto
     */
    invoiceDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof GetSalesInvoiceDto
     */
    saleDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof GetSalesInvoiceDto
     */
    dueDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceDto
     */
    amountNet?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceDto
     */
    amountGross?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceDto
     */
    status: GetSalesInvoiceDtoStatusEnum;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceDto
     */
    paymentForm: GetSalesInvoiceDtoPaymentFormEnum;
    /**
     * 
     * @type {Array<GetSalesInvoicePositionDto>}
     * @memberof GetSalesInvoiceDto
     */
    salesInvoicePositions?: Array<GetSalesInvoicePositionDto>;
    /**
     * 
     * @type {boolean}
     * @memberof GetSalesInvoiceDto
     */
    active: boolean;
    /**
     * 
     * @type {number}
     * @memberof GetSalesInvoiceDto
     */
    systemNumber: number;
    /**
     * 
     * @type {GetSalesInvoiceDto}
     * @memberof GetSalesInvoiceDto
     */
    parent: GetSalesInvoiceDto;
    /**
     * 
     * @type {GetSalesInvoiceDto}
     * @memberof GetSalesInvoiceDto
     */
    originalInvoice: GetSalesInvoiceDto;
    /**
     * 
     * @type {Array<GetSalesInvoiceDto>}
     * @memberof GetSalesInvoiceDto
     */
    corrections?: Array<GetSalesInvoiceDto>;
    /**
     * 
     * @type {GetCompanyDto}
     * @memberof GetSalesInvoiceDto
     */
    company: GetCompanyDto;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceDto
     */
    issuerId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceDto
     */
    recipientId?: string | null;
    /**
     * 
     * @type {GetCompanyDto}
     * @memberof GetSalesInvoiceDto
     */
    recipient?: GetCompanyDto | null;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceDto
     */
    recipientRole?: GetSalesInvoiceDtoRecipientRoleEnum | null;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceDto
     */
    recipientIdWew?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceDto
     */
    recipientRoleDescription?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceDto
     */
    recipientShare?: string | null;
    /**
     * 
     * @type {GetExaminedDto}
     * @memberof GetSalesInvoiceDto
     */
    examined?: GetExaminedDto;
    /**
     * 
     * @type {number}
     * @memberof GetSalesInvoiceDto
     */
    netSum?: number;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceDto
     */
    correctionReasonTxt?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceDto
     */
    additionalNotesTxt?: string | null;
    /**
     * 
     * @type {GetDictionaryDto}
     * @memberof GetSalesInvoiceDto
     */
    correctionReasonDict?: GetDictionaryDto;
    /**
     * 
     * @type {GetUserDto}
     * @memberof GetSalesInvoiceDto
     */
    approver?: GetUserDto;
    /**
     * 
     * @type {Date}
     * @memberof GetSalesInvoiceDto
     */
    approvedTs?: Date | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetSalesInvoiceDto
     */
    hasAttachments?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSalesInvoiceDto
     */
    toKsef: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSalesInvoiceDto
     */
    sendEmail: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSalesInvoiceDto
     */
    isPaid?: boolean;
    /**
     * 
     * @type {Date}
     * @memberof GetSalesInvoiceDto
     */
    paidDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceDto
     */
    statusKsef?: GetSalesInvoiceDtoStatusKsefEnum | null;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceDto
     */
    numberKsef?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceDto
     */
    qrCodeKsef?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceDto
     */
    qrCodeKsefVerification?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof GetSalesInvoiceDto
     */
    ksefDate?: Date | null;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceDto
     */
    ksefRejectionReason?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof GetSalesInvoiceDto
     */
    ts?: Date | null;
    /**
     * 
     * @type {Array<number>}
     * @memberof GetSalesInvoiceDto
     */
    examNumbers?: Array<number> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof GetSalesInvoiceDto
     */
    examIds?: Array<string> | null;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceDto
     */
    emailSentTo?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof GetSalesInvoiceDto
     */
    emailSentDate?: Date | null;
    /**
     * 
     * @type {GetUserDto}
     * @memberof GetSalesInvoiceDto
     */
    creator?: GetUserDto | null;
    /**
     * 
     * @type {Array<GetAttachmentDto>}
     * @memberof GetSalesInvoiceDto
     */
    attachments?: Array<GetAttachmentDto> | null;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceDto
     */
    linkableAmount?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceDto
     */
    remainingLinkableAmount?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetSalesInvoiceDto
     */
    autoGenerated: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetSalesInvoiceDto
     */
    autoApproved: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceDto
     */
    invoiceBuyerNip?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceDto
     */
    invoiceBuyerPesel?: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetSalesInvoiceDto
     */
    invoiceBuyerTaxIdentifier?: string | null;
}


/**
 * @export
 */
export const GetSalesInvoiceDtoStatusEnum = {
    Draft: 'Draft',
    Approved: 'Approved',
    InKSeF: 'InKSeF'
} as const;
export type GetSalesInvoiceDtoStatusEnum = typeof GetSalesInvoiceDtoStatusEnum[keyof typeof GetSalesInvoiceDtoStatusEnum];

/**
 * @export
 */
export const GetSalesInvoiceDtoPaymentFormEnum = {
    Cash: 'Cash',
    BankTransfer: 'BankTransfer',
    Card: 'Card',
    Mobile: 'Mobile'
} as const;
export type GetSalesInvoiceDtoPaymentFormEnum = typeof GetSalesInvoiceDtoPaymentFormEnum[keyof typeof GetSalesInvoiceDtoPaymentFormEnum];

/**
 * @export
 */
export const GetSalesInvoiceDtoRecipientRoleEnum = {
    Factor: 'Factor',
    Recipient: 'Recipient',
    OriginalEntity: 'OriginalEntity',
    AdditionalBuyer: 'AdditionalBuyer',
    PaymentEntity: 'PaymentEntity',
    Payer: 'Payer',
    LocalGovernmentIssuer: 'LocalGovernmentIssuer',
    LocalGovernmentRecipient: 'LocalGovernmentRecipient',
    VATGroupMemberIssuer: 'VATGroupMemberIssuer',
    VATGroupMemberRecipient: 'VATGroupMemberRecipient',
    Employee: 'Employee',
    OtherEntity: 'OtherEntity'
} as const;
export type GetSalesInvoiceDtoRecipientRoleEnum = typeof GetSalesInvoiceDtoRecipientRoleEnum[keyof typeof GetSalesInvoiceDtoRecipientRoleEnum];

/**
 * @export
 */
export const GetSalesInvoiceDtoStatusKsefEnum = {
    AcceptedInKSeF: 'AcceptedInKSeF',
    RejectedInKSeF: 'RejectedInKSeF',
    WaitingForKSeF: 'WaitingForKSeF'
} as const;
export type GetSalesInvoiceDtoStatusKsefEnum = typeof GetSalesInvoiceDtoStatusKsefEnum[keyof typeof GetSalesInvoiceDtoStatusKsefEnum];


/**
 * Check if a given object implements the GetSalesInvoiceDto interface.
 */
export function instanceOfGetSalesInvoiceDto(value: object): value is GetSalesInvoiceDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('number' in value) || value['number'] === undefined) return false;
    if (!('invoiceDate' in value) || value['invoiceDate'] === undefined) return false;
    if (!('saleDate' in value) || value['saleDate'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('paymentForm' in value) || value['paymentForm'] === undefined) return false;
    if (!('active' in value) || value['active'] === undefined) return false;
    if (!('systemNumber' in value) || value['systemNumber'] === undefined) return false;
    if (!('parent' in value) || value['parent'] === undefined) return false;
    if (!('originalInvoice' in value) || value['originalInvoice'] === undefined) return false;
    if (!('company' in value) || value['company'] === undefined) return false;
    if (!('toKsef' in value) || value['toKsef'] === undefined) return false;
    if (!('sendEmail' in value) || value['sendEmail'] === undefined) return false;
    if (!('autoGenerated' in value) || value['autoGenerated'] === undefined) return false;
    if (!('autoApproved' in value) || value['autoApproved'] === undefined) return false;
    return true;
}

export function GetSalesInvoiceDtoFromJSON(json: any): GetSalesInvoiceDto {
    return GetSalesInvoiceDtoFromJSONTyped(json, false);
}

export function GetSalesInvoiceDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetSalesInvoiceDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'number': json['number'],
        'invoiceDate': (new Date(json['invoiceDate'])),
        'saleDate': (new Date(json['saleDate'])),
        'dueDate': json['dueDate'] == null ? undefined : (new Date(json['dueDate'])),
        'amountNet': json['amountNet'] == null ? undefined : json['amountNet'],
        'amountGross': json['amountGross'] == null ? undefined : json['amountGross'],
        'status': json['status'],
        'paymentForm': json['paymentForm'],
        'salesInvoicePositions': json['salesInvoicePositions'] == null ? undefined : ((json['salesInvoicePositions'] as Array<any>).map(GetSalesInvoicePositionDtoFromJSON)),
        'active': json['active'],
        'systemNumber': json['systemNumber'],
        'parent': GetSalesInvoiceDtoFromJSON(json['parent']),
        'originalInvoice': GetSalesInvoiceDtoFromJSON(json['originalInvoice']),
        'corrections': json['corrections'] == null ? undefined : ((json['corrections'] as Array<any>).map(GetSalesInvoiceDtoFromJSON)),
        'company': GetCompanyDtoFromJSON(json['company']),
        'issuerId': json['issuerId'] == null ? undefined : json['issuerId'],
        'recipientId': json['recipientId'] == null ? undefined : json['recipientId'],
        'recipient': json['recipient'] == null ? undefined : GetCompanyDtoFromJSON(json['recipient']),
        'recipientRole': json['recipientRole'] == null ? undefined : json['recipientRole'],
        'recipientIdWew': json['recipientIdWew'] == null ? undefined : json['recipientIdWew'],
        'recipientRoleDescription': json['recipientRoleDescription'] == null ? undefined : json['recipientRoleDescription'],
        'recipientShare': json['recipientShare'] == null ? undefined : json['recipientShare'],
        'examined': json['examined'] == null ? undefined : GetExaminedDtoFromJSON(json['examined']),
        'netSum': json['netSum'] == null ? undefined : json['netSum'],
        'correctionReasonTxt': json['correctionReasonTxt'] == null ? undefined : json['correctionReasonTxt'],
        'additionalNotesTxt': json['additionalNotesTxt'] == null ? undefined : json['additionalNotesTxt'],
        'correctionReasonDict': json['correctionReasonDict'] == null ? undefined : GetDictionaryDtoFromJSON(json['correctionReasonDict']),
        'approver': json['approver'] == null ? undefined : GetUserDtoFromJSON(json['approver']),
        'approvedTs': json['approvedTs'] == null ? undefined : (new Date(json['approvedTs'])),
        'hasAttachments': json['hasAttachments'] == null ? undefined : json['hasAttachments'],
        'toKsef': json['toKsef'],
        'sendEmail': json['sendEmail'],
        'isPaid': json['isPaid'] == null ? undefined : json['isPaid'],
        'paidDate': json['paidDate'] == null ? undefined : (new Date(json['paidDate'])),
        'statusKsef': json['statusKsef'] == null ? undefined : json['statusKsef'],
        'numberKsef': json['numberKsef'] == null ? undefined : json['numberKsef'],
        'qrCodeKsef': json['qrCodeKsef'] == null ? undefined : json['qrCodeKsef'],
        'qrCodeKsefVerification': json['qrCodeKsefVerification'] == null ? undefined : json['qrCodeKsefVerification'],
        'ksefDate': json['ksefDate'] == null ? undefined : (new Date(json['ksefDate'])),
        'ksefRejectionReason': json['ksefRejectionReason'] == null ? undefined : json['ksefRejectionReason'],
        'ts': json['ts'] == null ? undefined : (new Date(json['ts'])),
        'examNumbers': json['examNumbers'] == null ? undefined : json['examNumbers'],
        'examIds': json['examIds'] == null ? undefined : json['examIds'],
        'emailSentTo': json['emailSentTo'] == null ? undefined : json['emailSentTo'],
        'emailSentDate': json['emailSentDate'] == null ? undefined : (new Date(json['emailSentDate'])),
        'creator': json['creator'] == null ? undefined : GetUserDtoFromJSON(json['creator']),
        'attachments': json['attachments'] == null ? undefined : ((json['attachments'] as Array<any>).map(GetAttachmentDtoFromJSON)),
        'linkableAmount': json['linkableAmount'] == null ? undefined : json['linkableAmount'],
        'remainingLinkableAmount': json['remainingLinkableAmount'] == null ? undefined : json['remainingLinkableAmount'],
        'autoGenerated': json['autoGenerated'],
        'autoApproved': json['autoApproved'],
        'invoiceBuyerNip': json['invoiceBuyerNip'] == null ? undefined : json['invoiceBuyerNip'],
        'invoiceBuyerPesel': json['invoiceBuyerPesel'] == null ? undefined : json['invoiceBuyerPesel'],
        'invoiceBuyerTaxIdentifier': json['invoiceBuyerTaxIdentifier'] == null ? undefined : json['invoiceBuyerTaxIdentifier'],
    };
}

export function GetSalesInvoiceDtoToJSON(value?: GetSalesInvoiceDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'number': value['number'],
        'invoiceDate': ((value['invoiceDate']).toISOString()),
        'saleDate': ((value['saleDate']).toISOString()),
        'dueDate': value['dueDate'] == null ? undefined : ((value['dueDate'] as any).toISOString()),
        'amountNet': value['amountNet'],
        'amountGross': value['amountGross'],
        'status': value['status'],
        'paymentForm': value['paymentForm'],
        'salesInvoicePositions': value['salesInvoicePositions'] == null ? undefined : ((value['salesInvoicePositions'] as Array<any>).map(GetSalesInvoicePositionDtoToJSON)),
        'active': value['active'],
        'systemNumber': value['systemNumber'],
        'parent': GetSalesInvoiceDtoToJSON(value['parent']),
        'originalInvoice': GetSalesInvoiceDtoToJSON(value['originalInvoice']),
        'corrections': value['corrections'] == null ? undefined : ((value['corrections'] as Array<any>).map(GetSalesInvoiceDtoToJSON)),
        'company': GetCompanyDtoToJSON(value['company']),
        'issuerId': value['issuerId'],
        'recipientId': value['recipientId'],
        'recipient': GetCompanyDtoToJSON(value['recipient']),
        'recipientRole': value['recipientRole'],
        'recipientIdWew': value['recipientIdWew'],
        'recipientRoleDescription': value['recipientRoleDescription'],
        'recipientShare': value['recipientShare'],
        'examined': GetExaminedDtoToJSON(value['examined']),
        'netSum': value['netSum'],
        'correctionReasonTxt': value['correctionReasonTxt'],
        'additionalNotesTxt': value['additionalNotesTxt'],
        'correctionReasonDict': GetDictionaryDtoToJSON(value['correctionReasonDict']),
        'approver': GetUserDtoToJSON(value['approver']),
        'approvedTs': value['approvedTs'] == null ? undefined : ((value['approvedTs'] as any).toISOString()),
        'hasAttachments': value['hasAttachments'],
        'toKsef': value['toKsef'],
        'sendEmail': value['sendEmail'],
        'isPaid': value['isPaid'],
        'paidDate': value['paidDate'] == null ? undefined : ((value['paidDate'] as any).toISOString()),
        'statusKsef': value['statusKsef'],
        'numberKsef': value['numberKsef'],
        'qrCodeKsef': value['qrCodeKsef'],
        'qrCodeKsefVerification': value['qrCodeKsefVerification'],
        'ksefDate': value['ksefDate'] == null ? undefined : ((value['ksefDate'] as any).toISOString()),
        'ksefRejectionReason': value['ksefRejectionReason'],
        'ts': value['ts'] == null ? undefined : ((value['ts'] as any).toISOString()),
        'examNumbers': value['examNumbers'],
        'examIds': value['examIds'],
        'emailSentTo': value['emailSentTo'],
        'emailSentDate': value['emailSentDate'] == null ? undefined : ((value['emailSentDate'] as any).toISOString()),
        'creator': GetUserDtoToJSON(value['creator']),
        'attachments': value['attachments'] == null ? undefined : ((value['attachments'] as Array<any>).map(GetAttachmentDtoToJSON)),
        'linkableAmount': value['linkableAmount'],
        'remainingLinkableAmount': value['remainingLinkableAmount'],
        'autoGenerated': value['autoGenerated'],
        'autoApproved': value['autoApproved'],
        'invoiceBuyerNip': value['invoiceBuyerNip'],
        'invoiceBuyerPesel': value['invoiceBuyerPesel'],
        'invoiceBuyerTaxIdentifier': value['invoiceBuyerTaxIdentifier'],
    };
}

